;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { Anchor } from '@qogita/ui/v2/anchor'
import { Icon } from '@qogita/ui/v2/icon'
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from '@qogita/ui/v2/modal'
import cloudflareLoader from 'imageLoader'
import NextImage from 'next/image'
import React, { useState } from 'react'
import Fallback from 'src/deprecated/components/shared/fallback.png'
import { vercelImageLoader } from 'src/deprecated/utils/url'

type ProductModalProps = {
  visible: boolean
  imageUrl: string
  url: string
  title: string
  setIsModalVisible: (open: boolean) => void
}

export function ProductModal({
  title,
  url,
  imageUrl,
  visible,
  setIsModalVisible,
}: ProductModalProps) {
  const [useFallbackImage, setUseFallbackImage] = useState(false)

  return (
    <Modal open={visible} onOpenChange={setIsModalVisible}>
      <ModalContent>
        <ModalHeader>
          <ModalTitle>{title}</ModalTitle>
        </ModalHeader>

        <ModalBody>
          <div className="flex flex-1 flex-col gap-4 px-8 pb-3">
            <NextImage
              src={useFallbackImage ? Fallback : imageUrl}
              layout="responsive"
              width={430}
              height={430}
              alt={title}
              onError={() => setUseFallbackImage(true)}
              loader={useFallbackImage ? vercelImageLoader : cloudflareLoader}
            />
          </div>
        </ModalBody>

        <ModalFooter>
          <div className="flex flex-1 items-center justify-center">
            {/* oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component */}
            <Anchor href={url} className="flex gap-2" variant="text">
              View item in Qogita catalog{' '}
              <Icon
                name="heroicons/solid/arrow-top-right-on-square"
                className="size-4.5"
              />
            </Anchor>
          </div>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
